import React, { useCallback, useRef } from 'react';

import { useMatch } from 'react-router-dom';

import { IBaseProps } from '@rbi-ctg/frontend';
import { EventName, emitEvent } from 'utils/event-hub';

import StyledLink from './styled-link';

interface INavLinkProps extends IBaseProps {
  to: string;
  hidden?: boolean;
  requiresExactMatch?: boolean;
  onClick?: () => void;
  className?: string;
}

export const NavLink = ({
  requiresExactMatch,
  to,
  children,
  'data-testid': dataQaId,
  onClick,
  hidden,
  className = '',
}: INavLinkProps) => {
  const ref = useRef<HTMLAnchorElement | null>(null);

  const handleClick = useCallback(() => {
    emitEvent(EventName.BOTTOM_TAB_PRESSED, {
      route: to,
    });

    if (onClick) {
      onClick();
    }
  }, [onClick, to]);

  const pathToMatch = requiresExactMatch ? to : `${to}/*`;
  const pathMatch = useMatch(pathToMatch);

  const activeClassName = pathMatch ? 'active' : '';

  return (
    <StyledLink
      to={to}
      onClick={handleClick}
      className={`${className} ${activeClassName}`}
      data-testid={dataQaId}
      ref={ref}
      tabIndex={hidden ? -1 : undefined}
    >
      {children}
    </StyledLink>
  );
};

export const iconSize = 25;
